<div id="anular-factura" class="k-form">
  <section class="position-relative">
    <div class="modal-header" >
      <span mat-dialog-close class="cursor-pointer btn-close-modal">
        <mat-icon>close</mat-icon>
      </span>
      <div class="modal-title border-0">
        <div class="bg-blue">
          <h2 mat-dialog-title color="primary">
            Anulação {{data?.tipo?.tipo}} {{ data?.codigo }}
          </h2>
        </div>
      </div>
    </div>

    <div class="modal-body pb-1 k-form-crud" >
      <div fxLayout="row wrap" >
       <ng-container>
         <div  fxFlex="100" fxFlex.gt-lg="100" class="mb-32 pr-1" >
           <mat-form-field appearance="outline" class="full-width">
             <mat-label>Seleccionar motivo</mat-label>
             <input matInput placeholder="Seleccionar motivo" [formControl]="ctrlMotivoSelecionado" (click)="filtrarAutocomplete($event)" (input)="filtrarAutocomplete($event)"
                    autofocus="off"  [matAutocomplete]="motivo" type="search">
             <mat-icon matSuffix class="cursor-pointer" (click)="filtrarAutocomplete($event)">arrow_drop_down</mat-icon>
           </mat-form-field>
           <mat-autocomplete autoActiveFirstOption #motivo="matAutocomplete">
             <mat-option *ngFor="let motivo of opcoes" [value]="motivo?.motivoEstado" (click)="selecMotivo(motivo)">
               <span style="font-size: 14px !important;" >{{motivo?.motivoEstado}}</span>
             </mat-option>
           </mat-autocomplete>
         </div>
       </ng-container>
      </div>

      <div fxLayout="row wrap" class="flex-y-center flex-x-btw" >
        <div fxFlex="100" fxFlex.xs="100"  *ngIf="MotivoCtrl.invalid && MotivoCtrl.touched">
          <small class="text-error px-1" *ngIf="MotivoCtrl.hasError('required')">Por favor escreva o motivo</small>
        </div>
      </div>
      <div fxLayout="row wrap" class="flex-y-center flex-x-btw" >
        <div fxFlex.xl="78" fxFlex.lg="78" fxFlex.md="70" fxFlex="100" class="pr-1" *ngIf="modoAdicao">
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Inserir motivo</mat-label>
            <input matInput placeholder="Inserir motivo" type="text" [formControl]="MotivoCtrl">
          </mat-form-field>
        </div>
        <div  fxFlex="100" fxFlex.xl="20" fxFlex.lg="20" fxFlex.md="30"  class="pr-1 pt-02" >
          <button class="bg-primary" type="button" mat-button *ngIf="modoAdicao" (click)="adicionarMotivo()">Gravar motivo</button>
          <button class="bg-primary" type="button" mat-button *ngIf="!modoAdicao" (click)="adNovoMotivo()">Adicionar motivo</button>
        </div>
      </div>
    </div>
    <div class="pb-8 pt-1 border-t">
      <div class="flex flex-x-btw pr-1 pl-1">
        <button
          mat-dialog-close
          class="bg-secondary mr-1 ml-1"
          mat-button
          type="button"
        >
          Cancelar
        </button>
        <button class="bg-primary mr-1" (click)="alterarEstadoDoc()" mat-button type="button">
          Confirmar
        </button>
      </div>
    </div>
  </section>
</div>
